import { render, staticRenderFns } from "./V2AddressSection.vue?vue&type=template&id=ba572c0e&scoped=true&"
import script from "./V2AddressSection.vue?vue&type=script&lang=js&"
export * from "./V2AddressSection.vue?vue&type=script&lang=js&"
import style0 from "./V2AddressSection.vue?vue&type=style&index=0&id=ba572c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba572c0e",
  null
  
)

export default component.exports